import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAppContext } from "../../contexts/AppContext";
import "./testimonials.css";
import parse from "html-react-parser";

function TestimonialDisplay() {
  const { backendUrl, translate, getImageUrl } = useAppContext();
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${backendUrl}/testimonialsList`);
        const approved = response.data
          .filter((t) => !!t.isApproved)
          .sort((a, b) => a.order - b.order);
        setTestimonials(approved);
      } catch (err) {
        console.error("Error fetching testimonials:", err);
      }
    };
    fetchTestimonials();
  }, [backendUrl]);

  useEffect(() => {
    if (testimonials.length === 0) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handleNext = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const handlePrev = () => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  if (!Array.isArray(testimonials) || testimonials.length === 0) return null;

  const testimonial = testimonials[currentIndex];

  return (
    <div className="testimonial-section">
      {/* Section Header */}
      <div className="testimonial-header">
        <p className="testimonial-label">{parse(translate("What Our Patients Say"))}</p>
        <h2 className="testimonial-heading">{parse(translate("Awesome Reviews"))}</h2>
        <div className="testimonial-accent" />
      </div>

      {/* Card */}
      <div className="testimonial-stage">
        <div className="testimonial-card-modern">
          {/* Quote mark */}
          <div className="quote-icon">
            <i className="bi bi-quote" />
          </div>

          {/* Comment */}
          <p className="testimonial-comment-modern">
            {/* {parse(translate(testimonial?.comment))} */}
            {testimonial?.comment}

          </p>

          {/* Stars */}
          <div className="testimonial-stars">
            {[1, 2, 3, 4, 5].map((s) => (
              <i key={s} className="bi bi-star-fill" />
            ))}
          </div>

          {/* Divider */}
          <div className="testimonial-divider" />

          {/* Author */}
          <div className="testimonial-author">
            <div className="testimonial-avatar">
              {testimonial.images?.[0] ? (
                <img
                  src={getImageUrl(testimonial.images[0])}
                  alt={testimonial.name}
                />
              ) : (
                <div className="testimonial-avatar-placeholder">
                  <i className="bi bi-person-fill" />
                </div>
              )}
            </div>
            <div>
              <h5 className="testimonial-author-name">{testimonial.name}</h5>

            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="testimonial-dots">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`dot ${i === currentIndex ? "dot-active" : ""}`}
              onClick={() => setCurrentIndex(i)}
            />
          ))}
        </div>

        {/* Navigation */}
        <div className="testimonial-nav">
          <button className="nav-btn-modern" onClick={handlePrev} aria-label="Previous">
            <i className="bi bi-chevron-left" />
          </button>
          <span className="testimonial-counter">
            {currentIndex + 1} / {testimonials.length}
          </span>
          <button className="nav-btn-modern" onClick={handleNext} aria-label="Next">
            <i className="bi bi-chevron-right" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default TestimonialDisplay;
